import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { API, formatApiError } from "@/lib/api";
import { IMAGES } from "@/lib/content";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await API.post("/auth/login", { email, password });
      localStorage.setItem("eid_token", data.access_token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err, "Login failed. Check your credentials."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="flex min-h-screen items-center justify-center px-6 pt-20" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="gold-ring-card p-10">
          <div className="flex flex-col items-center text-center">
            <img src={IMAGES.logo} alt="Elite Imperium Digital" className="h-12 w-auto rounded-sm" />
            <div className="mt-6 flex h-11 w-11 items-center justify-center rounded-full border border-gold/30 bg-gold/10">
              <Lock className="h-5 w-5 text-gold-glow" />
            </div>
            <h1 className="mt-5 font-serif text-2xl text-ivory">Admin Console</h1>
            <p className="mt-2 text-xs text-slate-500">Authorised access only</p>
          </div>
          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="admin-login-form">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Admin email"
              className="input-lux"
              data-testid="admin-email-input"
            />
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              className="input-lux"
              data-testid="admin-password-input"
            />
            {error && <p className="text-xs text-red-400" data-testid="admin-login-error">{error}</p>}
            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit-btn"
              className="flex w-full items-center justify-center gap-2 rounded-full bg-gold py-3.5 text-sm font-semibold text-navy-deep transition-colors duration-300 hover:bg-gold-light disabled:opacity-60"
            >
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Sign in"}
            </button>
          </form>
        </div>
        <p className="mt-6 text-center text-xs text-slate-600">
          <Link to="/" className="transition-colors duration-300 hover:text-gold-glow" data-testid="back-to-site-link">← Back to site</Link>
        </p>
      </div>
    </main>
  );
}
